<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-06-06 14:55:39
-->
<template>
  <div class="add-danwei">
    <el-form ref="ruleForm"
             :model="viewData"
             :rules="rules"
             label-width="100px">
      <el-form-item label="名称"
                    prop="name">
        <el-input size="mini"
                  v-model="viewData.name" />
      </el-form-item>
      <el-form-item label="状态"
                    prop="sort">
        <el-switch size="mini"
                   v-model="viewData.status"
                   class="drawer-switch"
                   active-color="#13ce66"
                   inactive-color="#ff4949"
                   :active-value="1"
                   :inactive-value="0" />
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;"
                 size="mini"
                 type="primary"
                 @click="tijiao('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
import Department from "@/api/console/Department";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      viewData: {
        section_id: "",
        name: "",
        status: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Pagination,
  },
  created () { },
  methods: {
    /**
     * @name: 初始化列表
     * @param {*} obj
     * @return {*}
     * @desc:
     */
    initFun (obj) {
      let that = this
      this.viewData = {
        section_id: "",
        name: "",
        status: 1,
      }
      if (obj.id) {
        // 编辑
        this.viewData.section_id = obj.id;
        Department.detail({ section_id: obj.id }).then((res) => {
          console.log(res)
          if (res.code == 200) {
            that.viewData = res.result
            that.viewData.section_id = res.result.id;
          }
        });
      } else {
        // 新增
      }
    },
    /**
     * @name: 提交
     * @param {*} formName
     * @return {*}
     * @desc: 
     */
    tijiao (formName) {
      let that = this
      console.log(this.viewData)
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.viewData.section_id) {
            // 编辑
            Department.edit(this.viewData).then(res => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.$emit('onUpdateDrawer', -1)
              }
            })
          } else {
            // 新增
            Department.create(this.viewData).then(res => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.$emit('onUpdateDrawer', 1)
              } else {
                that.$message.error(res.message);
                that.$emit('onUpdateDrawer', -1)
              }
            })
          }

        } else {
          this.$message.warning(this.$t('form.verifyMsg'))
        }
      })
    },
    /**
     * @name: 清空form
     * @return {*}
     * @desc:
     */
    resetForm () {
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
